import { createAPIRequestReducer } from "../api"
import ActionTypes from "../../enums/ActionTypes"

export default createAPIRequestReducer(ActionTypes.BASEDATA_TEMPLATES_LIST)
